import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import routes from './routes';
import { PageNotFound, PrivateRoute } from './Components/Common';

const router = createBrowserRouter([
  ...routes.map(({ path, component: Component, private: isPrivate }) => ({
    path,
    element: isPrivate ? <PrivateRoute component={Component} /> : <Component />
  })),
  { path: '*', element: <PageNotFound /> }
]);

export default router;
